/**
 * SODECO - Catálogo de misiones humanitarias (línea de tiempo)
 * --------------------------------------------------------------
 * Agrega, edita o elimina misiones directamente aquí.
 * Cada misión tiene su versión EN y ES.
 * --------------------------------------------------------------
 */

export const missions = [
    {
        id: "m-2008",
        year: 2008,
        location_en: "Santo Domingo, Dominican Republic",
        location_es: "Saint Domingo, Dominican Republic",
        title_en: "Foundation & First Mission",
        title_es: "Fundación y Primera Misión",
        description_en:
            "SODECO is founded. Our second relief mission delivers medical kits  to families affected by the Needs .",
        description_es:
            "Nace SODECO. Nuestra segunda misión de auxilio entrega kits médicos  familias afectadas por las Necesidades .",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1782269059/WhatsApp_Image_2026-05-15_at_23.50.15_bhdysl.jpg",
    },
    {
        id: "m-2011",
        year: 2011,
        location_en: "Monte Plata, Dominican Republic",
        location_es: "Monte Plata, República Dominicana",
        title_en: "Solidarity and Community Development",
        title_es: "Solidaridad y Desarrollo Comunitario",
        description_en:
            "Deployment of nutrition centers and pediatric care across refugee camps in Monte plata .",
        description_es:
            "Despliegue de centros de nutrición y atención pediátrica en campos de refugiados En Monte Plata.",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1782270021/WhatsApp_Image_2026-05-15_at_23.50.11_1_rtt2nh.jpg",
    },
    {
        id: "m-2014",
        year: 2014,
        location_en: "Higuey, Dominican Republic",
        location_es: "Higuey, República Dominicana",
        title_en: " Reconstruction",
        title_es: "Reconstrucción ",
        description_en:
            "Reconstruction of churches and schools, distribution of gifts to children..",
        description_es:
            "Reconstrucción de iglesias y escuelas, entrega de regalos a niños.",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1782270159/WhatsApp_Image_2026-05-15_at_23.50.13_3_hhwuka.jpg",
    },
    {
        id: "m-2017",
        year: 2017,
        location_en: "Cox's Bazar, Bangladesh",
        location_es: "Cox's Bazar, Bangladesh",
        title_en: "Emergency Food Crisis Relief",
        title_es: "Ayuda emergencia para crisis alimenticias",
        description_en:
            "Emergency response with hygiene kits, maternity care and child protection for displaced families.",
        description_es:
            "Respuesta de emergencia con kits de higiene, atención materna y protección infantil para familias desplazadas.",
        image:
            "https://images.unsplash.com/photo-1593113616828-6f22bca04804?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    },
    {
        id: "m-2019",
        year: 2019,
        location_en: "La Guajira, Colombia",
        location_es: "La Guajira, Colombia",
        title_en: "Indigenous Community Outreach",
        title_es: "Atención a Comunidades Indígenas",
        description_en:
            "Long-term partnership with Wayuu communities providing solar wells, schools, and maternal health programs.",
        description_es:
            "Alianza a largo plazo con comunidades Wayuu para pozos solares, escuelas y programas de salud materna.",
        image:
            "https://images.unsplash.com/photo-1617989586543-ef8404f8c85d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    },
    {
        id: "m-2021",
        year: 2021,
        location_en: "Lesvos, Greece",
        location_es: "Lesbos, Grecia",
        title_en: "Mediterranean Refugee Support",
        title_es: "Apoyo a Refugiados en el Mediterráneo",
        description_en:
            "Psychological care, legal aid and education for unaccompanied minors arriving on the Aegean coast.",
        description_es:
            "Atención psicológica, asesoría legal y educación para menores no acompañados que arriban a la costa del Egeo.",
        image:
            "https://images.unsplash.com/photo-1653575287854-8e77cb952eb7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    },
    {
        id: "m-2023",
        year: 2023,
        location_en: "Antakya, Türkiye",
        location_es: "Antakya, Turquía",
        title_en: "Earthquake Emergency Response",
        title_es: "Respuesta de Emergencia por Terremoto",
        description_en:
            "Mobile clinics, food distribution and trauma support in the first 96 hours after the disaster.",
        description_es:
            "Clínicas móviles, distribución de alimentos y apoyo emocional en las primeras 96 horas tras el desastre.",
        image:
            "https://images.unsplash.com/photo-1509099836639-18ba1795216d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    },
    {
        id: "m-2025",
        year: 2025,
        location_en: "Amazon Basin, Peru",
        location_es: "Cuenca Amazónica, Perú",
        title_en: "Climate Resilience Program",
        title_es: "Programa de Resiliencia Climática",
        description_en:
            "Reforestation, river-based health brigades and sustainable agriculture with riverine communities.",
        description_es:
            "Reforestación, brigadas de salud fluviales y agricultura sostenible junto a comunidades ribereñas.",
        image:
            "https://images.unsplash.com/photo-1603644448048-28a7e5122f0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    },
];

export default missions;
